import { action } from 'satcheljs';
import WacUrlInfo from 'owa-attachment-wac/lib/types/WacUrlInfo';

export const addComposeLinkViewState = action('ADD_COMPOSE_LINK_VIEW_STATE', (linkId: string) => ({
    linkId: linkId,
}));

export const removeAllComposeLinkViewStates = action('REMOVE_ALL_COMPOSE_LINK_VIEW_STATES');

export const previewSharePointDocumentLinkInSxS = action(
    'PREVIEW_SP_DOC_LINK_IN_SXS',
    (wacUrlGetter: () => Promise<WacUrlInfo>) => ({
        wacUrlGetter,
    })
);
